import PropTypes from 'prop-types';
import { Navigate, matchPath, useLocation } from 'react-router-dom';

import { getAuthPermissions, hasPermission, hasSubPermission, isAuthenticated } from 'utils/auth';

export default function ProtectedRoute({ children }) {
  const { pathname } = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const permissions = getAuthPermissions();
  const hasPermissionConfig = Array.isArray(permissions) && permissions.length > 0;

  const permissionRules = [
    {
      route: '/wareHouse/view',
      permission: 'warehouse',
      anySubPermissions: ['add-warehouse', 'view-warehouse', 'indent', 'visitor']
    },
    {
      route: '/wareHouse/details/:id',
      permission: 'warehouse',
      anySubPermissions: ['add-warehouse', 'view-warehouse', 'indent', 'visitor']
    },
    {
      route: '/wareHouse/details/:id/chamber',
      permission: 'warehouse',
      anySubPermissions: ['add-warehouse', 'view-warehouse', 'indent', 'visitor']
    },
    {
      route: '/wareHouse/details/:id/chamber/details/:chamberId',
      permission: 'warehouse',
      anySubPermissions: ['add-warehouse', 'view-warehouse', 'indent', 'visitor']
    },
    {
      route: '/wareHouse/details/:id/chamber/details/:chamberId/layout',
      permission: 'warehouse',
      anySubPermissions: ['add-warehouse', 'view-warehouse', 'indent', 'visitor']
    },
    {
      route: '/wareHouse/details/:id/layout',
      permission: 'warehouse',
      anySubPermissions: ['add-warehouse', 'view-warehouse', 'indent', 'visitor']
    },
    {
      route: '/wareHouse/details/:id/employees',
      permission: 'warehouse'
    }
  ];

  if (hasPermissionConfig) {
    const matchedRule = permissionRules.find((rule) => Boolean(matchPath({ path: rule.route, end: true }, pathname)));
    if (matchedRule) {
      const hasTopPermission = hasPermission(matchedRule.permission);
      const hasRequiredSubPermission = Array.isArray(matchedRule.anySubPermissions)
        ? matchedRule.anySubPermissions.some((subPermission) => hasSubPermission(matchedRule.permission, subPermission))
        : true;

      if (!hasTopPermission || !hasRequiredSubPermission) {
        return <Navigate to="/not-found" replace />;
      }
    }
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};
